export const SERVICES = [
  {
    key: "inputs",
    title: "Agricultural Inputs",
    icon: "sprout",
    description: "Quality seeds, fertilizers and crop protection products supplied at fair prices.",
  },
  {
    key: "feed",
    title: "Cattle Feed Production",
    icon: "milk",
    description: "Indapur Agro Feed — high quality nutritious feed for healthy livestock and better milk production.",
  },
  {
    key: "training",
    title: "Farmer Training",
    icon: "graduation-cap",
    description: "Modern farming techniques, best practices and on-field training programs.",
  },
  {
    key: "linkage",
    title: "Market Linkage",
    icon: "handshake",
    description: "Connecting farmers to better markets, fair prices and higher income opportunities.",
  },
];

export const PRODUCTS = [
  {
    key: "feed",
    name: "Indapur Agro Feed",
    tagline: "Premium Cattle Feed",
    description:
      "Nutrient-rich, balanced cattle feed for improved milk yield, healthier livestock and stronger farmer prosperity.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/53f7860f-a886-4cb3-b466-6962e3f74a5e/images/fe57866ddc696b158a299964bac59cd0ed2b8b785d559453b1dcdc8a9071a7ab.png",
  },
  {
    key: "seeds",
    name: "Certified Seeds",
    tagline: "High-Yield Varieties",
    description: "Quality certified seeds of major crops — selected for higher yield, disease resistance and reliability.",
    image:
      "https://images.unsplash.com/photo-1530507629858-e3759c1c3666?auto=format&fit=crop&w=800&q=80",
  },
  {
    key: "fertilizer",
    name: "Fertilizers",
    tagline: "Balanced Nutrition",
    description: "Effective fertilizers — organic and conventional — for healthy soil and abundant harvests.",
    image:
      "https://images.unsplash.com/photo-1599577180589-0a1f6e6a5b71?auto=format&fit=crop&w=800&q=80",
  },
  {
    key: "protection",
    name: "Crop Protection",
    tagline: "Trusted Solutions",
    description: "Reliable crop protection products to safeguard your harvest from pests and diseases.",
    image:
      "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?auto=format&fit=crop&w=800&q=80",
  },
];

export const GALLERY = [
  {
    url: "https://images.pexels.com/photos/29465456/pexels-photo-29465456.jpeg?auto=compress&cs=tinysrgb&w=900",
    caption: "Tractor on farm",
  },
  {
    url: "https://images.unsplash.com/photo-1641939193329-7071068dc40f?auto=format&fit=crop&w=900&q=80",
    caption: "Cattle grazing in field",
  },
  {
    url: "https://images.unsplash.com/photo-1551754655-cd27e38d2076?auto=format&fit=crop&w=900&q=80",
    caption: "Maize crop",
  },
  {
    url: "https://images.pexels.com/photos/29039798/pexels-photo-29039798.jpeg?auto=compress&cs=tinysrgb&w=900",
    caption: "Farmer in paddy field",
  },
  {
    url: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?auto=format&fit=crop&w=900&q=80",
    caption: "Rolling farmland",
  },
  {
    url: "https://images.unsplash.com/photo-1574943320219-553eb213f72d?auto=format&fit=crop&w=900&q=80",
    caption: "Harvest season",
  },
];

export const ACTIVITIES = [
  {
    title: "Farmer Training Workshops",
    description:
      "Regular training programs on modern farming techniques, soil health and water conservation conducted by experts.",
    image: "https://images.unsplash.com/photo-1605000797499-95a51c5269ae?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "Cattle Feed Production Unit",
    description:
      "Operational state-of-the-art cattle feed production facility delivering quality Indapur Agro Feed.",
    image: "https://static.prod-images.emergentagent.com/jobs/53f7860f-a886-4cb3-b466-6962e3f74a5e/images/fe57866ddc696b158a299964bac59cd0ed2b8b785d559453b1dcdc8a9071a7ab.png",
  },
  {
    title: "Field Visits & Demonstrations",
    description: "On-farm demonstrations of best practices, new crop varieties and innovative techniques.",
    image: "https://images.pexels.com/photos/29039800/pexels-photo-29039800.jpeg?auto=compress&cs=tinysrgb&w=900",
  },
  {
    title: "Market Linkage Programs",
    description:
      "Connecting farmers directly with buyers, traders and exporters to ensure better prices and timely payments.",
    image: "https://images.pexels.com/photos/29465456/pexels-photo-29465456.jpeg?auto=compress&cs=tinysrgb&w=900",
  },
];

export const PARTNERS = [
  {
    name: "NABARD",
    description: "National Bank for Agriculture and Rural Development — supporting rural prosperity.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/53f7860f-a886-4cb3-b466-6962e3f74a5e/images/949cf8f2e32703c278892999e3479cf33997471d123b099d38b2918ecde9d964.png",
  },
  {
    name: "NABFOUNDATION",
    description: "Promoting livelihoods, sustainability and farmer-led collective enterprises.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/53f7860f-a886-4cb3-b466-6962e3f74a5e/images/3f4368f0b7ea6e8cefe2b6876513e148091a20beceaa8ff6af722e930620c9ca.png",
  },
];

export const STATS = [
  { label: "Farmers Connected", value: "1000+" },
  { label: "Districts Covered", value: "3+" },
  { label: "Training Programs", value: "50+" },
  { label: "Products & Services", value: "10+" },
];
